import { IRewardPeriode } from '@pages/reward-setting/reward-setting.interface';
import { IGenericIdName } from '@shared/interface/generic';
import {
  IProgramProductScan,
  IProgramProductScan__Conversion,
} from '@pages/sales-marketing/program-marketing/program-marketing-retailer/retailer-program-form/retailer-program-form.interface';

export class InputSelectMaterialInterface {
  value: string;
  label: string;
  disabled?: boolean;
  labelExtra?: string;
  code?: string;
  description?: string;
}

export class ISelectPeriode extends InputSelectMaterialInterface {
  labelEnum: string;
  setPeriodeOptions(_selector: IRewardPeriode) {
    const { id, name, status_enum } = _selector;
    this.value = id;
    this.label = name;
    this.labelEnum = status_enum;
  }
}

export class ISelectGenericIdName extends InputSelectMaterialInterface {
  setOptions(_selector: IGenericIdName) {
    const { id, name } = _selector;
    this.value = id;
    this.label = name;
    return this;
  }
}

export class ISelectMultiLevelTarget extends InputSelectMaterialInterface {
  index: number;
  setOptions(_selector: { enum_level: string; string_level: string; index: number }) {
    const { enum_level, string_level, index } = _selector;
    this.value = enum_level;
    this.label = string_level;
    this.index = index;
  }
}

export class ISelectProductConversion extends InputSelectMaterialInterface {
  delivery_unit: string;
  conversion: IProgramProductScan__Conversion[];

  setOptions(_selector: IProgramProductScan) {
    const { variant_id, variant_name, delivery_unit } = _selector;
    this.value = variant_id;
    this.label = variant_name as string;
    this.delivery_unit = delivery_unit as string;
    this.disabled = false;
  }
}
